/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { useEffect } from 'react';

export function usePatchFloatingFocusGuards() {
  useEffect(() => {
    const patchGuards = () => {
      const guards = document.querySelectorAll(
        '[data-floating-ui-focus-guard]',
      );
      guards.forEach((el) => {
        el.setAttribute('aria-hidden', 'true');
        el.removeAttribute('role');
      });
    };

    // Initial patch (in case it's already there)
    patchGuards();

    const observer = new MutationObserver(() => {
      patchGuards();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);
}
